import React, { type ComponentProps } from 'react';
import { generatePath, Navigate, useParams } from 'react-router-dom';

const NavigateWithParams: React.FC<ComponentProps<typeof Navigate>> = ({ to, ...props }) => {
  const params = useParams();

  if (typeof to === 'string') {
    return <Navigate {...props} to={generatePath(to, params)} />;
  }
  return (
    <Navigate
      {...props}
      to={{
        ...to,
        pathname: to.pathname ? generatePath(to.pathname, params) : undefined,
      }}
    />
  );
};

export default NavigateWithParams;
